<!-- Team Colors -->
<template>
  <div
    class="customization-step"
    v-if="!customSpiritwearTextLoading && !customDecorationTextLoading"
  >
    <section class="team-colors">
      <label>Team Colors</label>
      <div class="color-pickers-container">
        <ColorPicker
          :colorPickerMode="'multiple'"
          :colorsToChange="projectColors"
          @selectColor="handleSelectColor"
        />
      </div>
    </section>

    <!-- Team Uniform Decoration -->
    <section class="team-decorations" v-if="uniformThumbnail">
      <label>Team Uniform Decoration</label>
      <TeamDecorationBox
        v-if="!customDecorationTextLoading"
        :typeOfDecoration="'team uniform'"
      />
      <Loader v-else />
    </section>

    <!-- Spiritwear Decoration -->
    <section class="team-decorations" v-if="spiritwearThumbnail">
      <label>Spiritwear Decoration</label>
      <TeamDecorationBox
        v-if="!customSpiritwearTextLoading"
        :typeOfDecoration="'spiritwear'"
      />
      <Loader v-else />
    </section>
  </div>
  <div class="customization-step" v-else>
    <Loader />
  </div>
</template>

<script>
import ColorPicker from "@/components/Projects/Project/Colors/ColorPicker.vue";
import TeamDecorationBox from "@/components/Projects/Showrooms/CustomizationBox/TeamDecorationBox.vue";
import Loader from "@/components/Utils/Loader";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "CustomizationStep1",

  computed: {
    ...mapGetters("project", ["projectColors"]),

    ...mapState("showroom", [
      "customDecorationTextLoading",
      "customSpiritwearTextLoading",
    ]),
    ...mapState("threekit", ["spiritwearThumbnail", "uniformThumbnail"]),
  },

  methods: {
    ...mapActions("showroom", [
      "readCustomizationsHelp",
      "updateShowroomColor",
      "setUniformDecorationLoading",
      "setSpiritwearDecorationLoading",
    ]),
    handleSelectColor({ color, colorKey }) {
      if (colorKey === "color_2" || colorKey === "color_3") {
        this.$store.commit("showroom/SET_UNIFORM_DECORATION_LOADING", true);
        this.$store.commit("showroom/SET_SPIRITWEAR_DECORATION_LOADING", true);

        if (colorKey === "color_2") {
          this.$store.commit("project/SET_SPIRITWEAR_FILL_COLOR", color.id);
          this.$store.commit("project/SET_UNIFORM_FILL_COLOR", color.id);
        } else {
          this.$store.commit("project/SET_SPIRITWEAR_OUTLINE_COLOR", color.id);
          this.$store.commit("project/SET_UNIFORM_OUTLINE_COLOR", color.id);
        }
      }

      setTimeout(() => {
        console.log("update");
        this.updateShowroomColor({ colorId: color?.id, colorKey });
      }, 500);
    },
  },

  components: {
    ColorPicker,
    TeamDecorationBox,
    Loader,
  },
};
</script>

<style lang="scss" scoped>
#app {
  .customization-step {
    margin: 10px 0;

    .team-decorations {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 1rem;

      .team-decoration-box {
        width: 100%;
      }
    }

    ::v-deep .color-picker-multiple-container {
      overflow-y: scroll !important;
      max-height: 60vh !important;

      .color-picker-multiple-header {
        position: sticky;
        top: 0;
        z-index: 10;
      }
    }
  }
}
</style>
